<template>
  <div
    class="visit-block card"
    :class="{
      'canceled': visit.status === 'Odwołana',
    }"
  >
    <div
      class="auto-info"
      :class="{
        'hide': !showCarBlock
      }"
    >
      <car-block
        v-if="showCarBlock"
        :car="car"
        mode="visit"
      />
    </div>
    <div class="visit-info">
      <div
        class="visit-info-element"
        v-if="visit.date"
      >
        <p class="label">
          Termin wizyty
        </p>
        <p class="visit-date">
          {{ formatDate(visit.date) }}
        </p>
      </div>
      <div
        class="visit-info-element"
      >
        <p class="label">
          Zakres usług
        </p>
        <p class="visit-type">
          <template v-for="(service, index) in visit.services">
            <span
              :key="'type' + index"
            >
              {{ service.name }}
            </span>
            <img
              :key="'image' + index"
              v-if="service.description && !isMobile"
              class="car-service-info-icon"
              v-tooltip.top="{ content: service.description, classes: 'car-service-tooltip' }"
              src="../assets/icons/system-info-small.svg"
              alt=""
            >
            <span
              :key="'comma' + index"
              :class="{ 'left-margin': !service.description }"
            >
              {{ index === visit.services.length - 1 ? '' : ',' }}
            </span>
          </template>
        </p>
      </div>
      <div class="visit-info-element">
        <p class="label">
          Koszt wizyty
        </p>
        <p class="visit-cost">
          {{ visitCost !== '0.00 PLN' ? visitCost : '-' }}
        </p>
      </div>
    </div>
    <div class="aso-info">
      <service-station-block
        class="visit"
        :show-details="false"
        :show-page-link="isMobile"
        :service-station="getServiceStationByID(visit.asoID)"
        :with-slot="true"
      />
    </div>
    <div
      class="controls-container"
      :class="{
        'mobile': isMobile,
      }"
      v-if="type !== 'history'"
    >
      <button
        class="visit-control-button"
        v-if="visit.status !== 'Odwołana'"
        @click="buttonAction('new')"
        v-tooltip.left="{ content: 'Umów nową wizytę', classes: 'car-block-tooltip' }"
      >
        <svg class="icon" svg-inline="" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="49" height="49" viewBox="0 0 49 49"><image width="49" height="49" xlink:href="data:image/png;base64,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"/></svg>
      </button>
      <!--       <button
        class="visit-control-button"
        v-if="visit.status !== 'Odwołana'"
        @click="buttonAction('edit')"
        v-tooltip.left="{ content: 'Edytuj wizytę', classes: 'car-block-tooltip' }"
      >
        <svg class="icon" svg-inline="" role="presentation" focusable="false" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M11.8 4.2l6.6 3.1-2.6 5.5m-10.3 5l3.6 1.7m-3.6-1.7v4.7l3.6-3 7.5-16c.2-.3 0-.7-.3-.9l-2.4-1.1c-.3-.2-.7 0-.9.3l-7.5 16z" stroke="currentColor" fill="none"/></svg>
      </button> -->
      <button
        class="visit-control-button"
        v-if="visit.status !== 'Odwołana'"
        @click="openModal()"
        v-tooltip.left="{ content: 'Odwołaj wizytę', classes: 'car-block-tooltip' }"
      >
        <svg class="icon" svg-inline="" role="presentation" focusable="false" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 9v10.5c0 .5.4 1 1 1h10c.5 0 1-.5 1-1V9m-6-3.5v-2m-1.5 0h3m-9.5 4h16l-1.4-2H4.9l-1.4 2z" stroke="currentColor" fill="none"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
import ServiceStationBlock from '~/ServiceStationBlock';
import CarBlock from '~/CarBlock';
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';

export default {
  props: {
    visit: {
      type: Object,
      default: () => {},
    },
    car: {
      type: Object,
      default: () => {},
    },
    serviceStation: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    showCarBlock: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      serviceStations: 'serviceStations/getServiceStations',
      allModels: 'brand/getSpecificModels',
    }),
    buttonText() {
      if (this.type === 'next' && this.visit.status !== 'Odwołana') {
        return 'Odwołaj wizytę';
      } if (this.type === 'next' && this.visit.status === 'Odwołana') {
        return 'Odwołana';
      }
      return 'Nowa wizyta';
    },
    getModelID() {
      if (this.car) {
        return this.allModels.find(model => model.name === this.car.name
            && model.transmission === this.car.transmission
            && model.power === this.car.power
            && model.capacity === this.car.capacity);
      }
      return null;
    },
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
    visitCost() {
      return `${this.visit.grossPrice.toFixed(2)} PLN`.replace('.', ',');
    },
  },
  components: {
    CarBlock,
    ServiceStationBlock,
  },
  methods: {
    ...mapActions({
      setModalContent: 'modal/setContent',
      setCallback: 'modal/setCallback',
      toggleModal: 'modal/openModal',
      setModalMode: 'modal/setModalMode',
      setModalStep: 'modal/setModalStep',
      setCarID: 'visit/setSelectedCarModelID',
      setLicensePlate: 'visit/setSelectedLicensePlate',
      setVinNumber: 'visit/setSelectedVin',
      setSelectedVisitDate: 'visit/setSelectedVisitDate',
      setRegisteredVisit: 'visit/setRegistered',
      setSelectedPrice: 'visit/setPrice',
      setSelectedPartner: 'visit/setSelectedPartner',
      setSelectedServices: 'visit/setSelectedServices',
      setSelectedLicensePlate: 'visit/setSelectedLicensePlate',
      setSelectedVin: 'visit/setSelectedVin',
      setSelectedCarModelID: 'visit/setSelectedCarModelID',
      setMileage: 'visit/setMileage',
    }),
    formatDate(date) {
      return dayjs(date).format('DD.MM.YYYY hh:mm');
    },
    getServiceStationByID(id) {
      return this.serviceStations.find(station => station.id === id);
    },
    buttonAction(type) {
      if (type === 'new') {
        this.$router.push({ path: `/dashboard/visits/new/${this.getModelID.id}/station` });

        this.resetVisitSpecs();
        this.setSelectedCarModelID(this.getModelID.id);
        this.setSelectedLicensePlate(this.car.licensePlate);
        this.setSelectedVin(this.car.vin);
      } else if (type === 'edit') {
        this.$router.push({ path: `/dashboard/visits/edit/${this.getModelID.id}/station` });

        this.setSelectedCarModelID(this.getModelID.id);
        this.setSelectedLicensePlate(this.car.licensePlate);
        this.setSelectedVin(this.car.vin);
        this.setSelectedPartner(this.getServiceStationByID(this.visit.asoID));
        this.setSelectedVisitDate({
          day: dayjs(this.visit.date).format('YYYY-MM-DD'),
          time: dayjs(this.visit.date).format('hh:mm'),
        });
        this.setSelectedServices(this.visit.services);
        this.setRegisteredVisit(this.visit);
      }
    },
    openModal() {
      this.setModalContent({
        title: 'Odwołaj wizytę',
        additional: {
          visit: this.visit,
        },
      });
      this.setModalMode('logged-in');
      this.setModalStep('cancel_visit');
      this.toggleModal();
    },
    resetVisitSpecs() {
      this.setSelectedPartner(null);
      this.setSelectedServices(null);
      this.setSelectedVisitDate(null);
      this.setRegisteredVisit(null);
      this.setMileage(0);
    },
  },
};
</script>
